/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Compare_Blocked_PipelineInputs */

const en_us2_body_assessment_compare_blocked_pipeline = /** @type {(inputs: Body_Assessment_Compare_Blocked_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The two were computed by different versions of the calculation, so the difference between them would say nothing about your body. It comes back once both are recomputed.`)
};

const pt_br2_body_assessment_compare_blocked_pipeline = /** @type {(inputs: Body_Assessment_Compare_Blocked_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As duas foram calculadas por versões diferentes do cálculo, então a diferença entre elas não diria nada sobre o seu corpo. Ela volta quando as duas forem recalculadas.`)
};

const es_419_body_assessment_compare_blocked_pipeline = /** @type {(inputs: Body_Assessment_Compare_Blocked_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las dos se calcularon con versiones diferentes del cálculo, así que la diferencia entre ellas no diría nada sobre tu cuerpo. Vuelve a aparecer cuando ambas se recalculen.`)
};

const pt_pt2_body_assessment_compare_blocked_pipeline = /** @type {(inputs: Body_Assessment_Compare_Blocked_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As duas foram calculadas por versões diferentes do cálculo, por isso a diferença entre elas não diria nada sobre o teu corpo. Volta quando as duas forem recalculadas.`)
};

const fr_fr2_body_assessment_compare_blocked_pipeline = /** @type {(inputs: Body_Assessment_Compare_Blocked_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les deux ont été calculées par des versions différentes du calcul, donc leur écart ne dirait rien de ton corps. Il réapparaît quand les deux sont recalculées.`)
};

const de_de2_body_assessment_compare_blocked_pipeline = /** @type {(inputs: Body_Assessment_Compare_Blocked_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die beiden wurden mit unterschiedlichen Versionen der Berechnung ermittelt, daher würde der Unterschied nichts über deinen Körper aussagen. Er erscheint wieder, sobald beide neu berechnet sind.`)
};

const it_it2_body_assessment_compare_blocked_pipeline = /** @type {(inputs: Body_Assessment_Compare_Blocked_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le due sono state calcolate da versioni diverse del calcolo, quindi la differenza tra loro non direbbe nulla sul tuo corpo. Tornerà quando entrambe saranno ricalcolate.`)
};

/**
* | output |
* | --- |
* | "The two were computed by different versions of the calculation, so the difference between them would say nothing about your body. It comes back once both are..." |
*
* @param {Body_Assessment_Compare_Blocked_PipelineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_compare_blocked_pipeline = /** @type {((inputs?: Body_Assessment_Compare_Blocked_PipelineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Compare_Blocked_PipelineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_compare_blocked_pipeline(inputs)
	if (locale === "es-419") return es_419_body_assessment_compare_blocked_pipeline(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_compare_blocked_pipeline(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_compare_blocked_pipeline(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_compare_blocked_pipeline(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_compare_blocked_pipeline(inputs)
	return en_us2_body_assessment_compare_blocked_pipeline(inputs)
});
export { body_assessment_compare_blocked_pipeline as "body-assessment.compare_blocked_pipeline" }